// Puente entre el interceptor de axios (vive fuera de Vue) y el dialog global
// de "Sesion expirada". El interceptor llama notifySessionExpired() cuando el
// backend devuelve 401 con la sesion activa; SessionExpiredDialog.vue se
// suscribe al mount y abre el modal.

let listener = null

export function subscribeSessionExpired(cb) {
  listener = cb
  return () => {
    if (listener === cb) listener = null
  }
}

export function notifySessionExpired() {
  if (listener) listener()
}
